/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Settingcount1Inputs */

const en_entity_settingcount1 = /** @type {(inputs: Entity_Settingcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setting Count`)
};

const de_entity_settingcount1 = /** @type {(inputs: Entity_Settingcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungsanzahl`)
};

/**
* | output |
* | --- |
* | "Setting Count" |
*
* @param {Entity_Settingcount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_settingcount1 = /** @type {((inputs?: Entity_Settingcount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Settingcount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_settingcount1(inputs)
	return de_entity_settingcount1(inputs)
});
export { entity_settingcount1 as "entity_settingCount" }